import { render } from "./BurgerMenuComp.vue?vue&type=template&id=647808cb&scoped=true"
import script from "./BurgerMenuComp.vue?vue&type=script&lang=js"
export * from "./BurgerMenuComp.vue?vue&type=script&lang=js"

import "./BurgerMenuComp.vue?vue&type=style&index=0&id=647808cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647808cb"]])

export default __exports__